export const S3URL = process.env.REACT_APP_S3_URL;
export const CLIENT_URL = process.env.REACT_APP_CLIENT_URL;
export const SOCKET_URL = process.env.REACT_APP_SOCKET_URL;

export const BASE = "http://localhost:9000";
